'use client';

import { FaturasScreen } from '@/components/faturas/FaturasScreen';
import { useChatPage } from '@/hooks/useChatPage';

export default function FaturasPage() {
  useChatPage('expenses');
  return (
    <div data-onboarding-invoices-page>
      <FaturasScreen />
    </div>
  );
}
